<template>
  <div class="mobileViewStyle follow-detail">
    <!-- 新增客户跟进（企业微信手机端） -->
    <div class="detail-body">
      <list-card label="跟进信息" type="form">
        <data-input label="客户">
          <mobile-search-select v-model="dataDetail.partnerId" :query="queryCustomerPage"
                                label-column="merchantRemarkName" code-column="id"
                                placeholder="请选择客户" search-placeholder="客户名称/手机号"
                                :display-text="customerName" @change="customerName = ''">
            <!-- 客户名称下方补一行联系电话：同名客户最容易记混，电话能区分 -->
            <template #item="{item}">
              <div class="mss-item">
                <div class="mss-item-main">{{ item.merchantRemarkName }}</div>
                <div class="mss-item-sub">{{ item.merchantRemarkPhone || "无联系电话" }}</div>
              </div>
            </template>
          </mobile-search-select>
        </data-input>
        <data-input label="跟进内容" v-model="dataDetail.followContent" placeholder="请输入本次沟通的情况"/>
        <data-input label="跟进时间">
          <mobile-date-select v-model="dataDetail.followTime" placeholder="请选择日期"/>
        </data-input>
        <data-input label="下次跟进">
          <mobile-date-select v-model="dataDetail.nextFollowDate" placeholder="请选择日期"/>
        </data-input>
      </list-card>
    </div>

    <div class="detail-footer">
      <mobile-button el-type="primary" @click="saveData">保存</mobile-button>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataInput from "@/components/qywx/data/DataInput.vue";
import MobileSearchSelect from "@/components/qywx/data/MobileSearchSelect.vue";
import MobileDateSelect from "@/components/qywx/data/MobileDateSelect.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";
import customerFollowApi from "@/api/normal/common/customerFollowApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import {PARTNER_TYPE} from "@/views/h5/crm/crmDictionary";

/** 取本地当天的 yyyy-MM-dd。不能用 toISOString()：它是 UTC，东八区凌晨会退到前一天 */
function today() {
  const d = new Date();
  const pad = n => String(n).padStart(2, "0");
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "CFD",
  components: {
    MobileButton, MobileSearchSelect, MobileDateSelect, DataInput, ListCard
  },
  data() {
    return {
      dataDetail: {
        partnerId: "",
        followContent: "",
        // 默认当天，与 web 端一致
        followTime: today(),
        nextFollowDate: "",
      },
      customerName: "", // 客户回显（从客户详情点「跟进」进来时带过来的）
      pageTitle: "",
    };
  },
  created() {
    this.pageTitle = document.title;
    document.title = "新增跟进";
    // 从客户详情点「跟进」过来会带上客户，预填；用户仍可重新选
    this.dataDetail.partnerId = this.route.query.partnerId || "";
    this.customerName = this.route.query.partnerName || "";
  },
  unmounted() {
    document.title = this.pageTitle;
  },
  methods: {
    // 客户选择框的数据源：走通用往来单位接口（带数据权限），需要显式传 partnerType
    queryCustomerPage(params) {
      return commonDataApi.queryPartnerList({...params, partnerType: PARTNER_TYPE.CUSTOMER});
    },
    saveData() {
      if (!this.dataDetail.partnerId) {
        this.$message.error("请选择客户");
        return;
      }
      if (!this.dataDetail.followContent) {
        this.$message.error("请填写跟进内容");
        return;
      }
      // 成功提示由请求拦截器统一弹（save*** 接口），这里不再自己弹
      customerFollowApi.saveFollow(this.dataDetail).then(() => {
        this.router.back();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.follow-detail{
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--yq-background-color);
  .detail-body{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
  }
  .detail-footer{
    flex: none;
    padding: 10px;
    background: #FFF;
    box-shadow: 0 -1px 4px var(--yq-shadow);
  }
  // 客户选择控件放在表单行里：字号跟随整行（组件默认 12px 是给查询条件用的）
  :deep(.select-area){
    font-size: inherit;
  }
}
</style>
